var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIntersecting)?_c('img',{class:_vm.customClass,attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('img',{class:_vm.customClass,attrs:{"src":_vm.loading,"alt":"Loading..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }